<template>
    <textarea
           ref="textarea"
           class="input w-full block flex-1 p-2 rounded placeholder:text-gray-400 bg-transparent border border-neutral-300 dark:border-neutral-500"
           @input="handleInput"
           :placeholder="placeholder"
           :rows="rows"
           :class="autoResize ? 'overflow-y-hidden' : null"
    >{{modelValue}}</textarea>
</template>

<script>
export default {
  name: 'TextareaInput',
  mounted() {
    this.resizeToContent();
  },
  methods: {
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value);
      this.resizeToContent();
    },
    resizeToContent() {
      if (!this.autoResize || !this.$refs.textarea) {
        return;
      }

      this.$refs.textarea.style.height = 'auto';
      this.$refs.textarea.style.height = `${this.$refs.textarea.scrollHeight + 2}px`;
    },
  },
  props: {
    autoResize: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      type: String,
      required: false,
    },
    modelValue: {
      required: true,
    },
    rows: {
      default: 3,
      type: Number,
    }
  },
  watch: {
    modelValue() {
      this.$nextTick(this.resizeToContent);
    },
  }
}
</script>

<style scoped lang="scss">

</style>
